export const updateBusinessID = (id, apikey) => {
  const user = localStorage.getItem('user');
  const originalBusinessObject = localStorage.getItem('originalBusinessObject');
  if (user) {
    const userInfo = JSON.parse(user);
    if (!originalBusinessObject) {
      const info = {
        businessid: userInfo.businessid,
        apikey: userInfo.apikey,
      };
      localStorage.setItem('originalBusinessObject', JSON.stringify(info));
    }
    userInfo.businessid = id;
    userInfo.business.businessid = id;
    userInfo.apikey = apikey;
    userInfo.business.apiKey = apikey;

    localStorage.setItem('user', JSON.stringify(userInfo));
    return {
      success: true,
      user: userInfo,
    };
  }

  return {
    success: false,
    error: 'Business ID not updated',
  };
};

export const resetBusinessID = () => {
  const user = localStorage.getItem('user');
  const originalBusinessObject = localStorage.getItem('originalBusinessObject');
  if (user && originalBusinessObject) {
    const userInfo = JSON.parse(user);
    const parsedObi = JSON.parse(originalBusinessObject);

    userInfo.businessid = parsedObi.businessid;
    userInfo.business.businessid = parsedObi.businessid;
    userInfo.apikey = parsedObi.apikey;
    userInfo.business.apikey = parsedObi.apikey;

    localStorage.setItem('user', JSON.stringify(userInfo));
    localStorage.removeItem('originalBusinessObject');
    return {
      success: true,
      user: userInfo,
    };
  }

  return {
    success: false,
    error: 'Could not switch back Business ID',
  };
};
